export const Theme = {
  fonts: {
    main: "roboto,sans-serif",
    code: "fira code,monospace",
  },
  fontSizes: {
    small: "1rem",
    medium: "2rem",
    large: "3rem",
  },
  breakpoints: {
    mobile: "800px",
  },
}
export const darkTheme = {
  text: "white",
  headings: "#7A8BE6",
  background: "#01142A",
  border: "#7A8BE6",
  gradient: "linear-gradient(#091236, #1E215D)",
  darkTheme: true,
  shadow: "-6px 6px 3px rgba(122, 139, 230, 0.2)",
  hoverShadow: "-12px 12px 6px rgba(122, 139, 230, 0.2)",
  codeBackground: "#2a3980",
}

export const lightTheme = {
  text: "#1D1A1A",
  headings: "#0077AC",
  background: "white",
  border: "#0077AC",
  gradient: "linear-gradient(#39598A, #79D7ED)",
  lightTheme: true,
  shadow: "-6px 6px 3px rgba(41, 42, 46, 0.2)",
  hoverShadow: "-12px 12px 6px rgba(0, 0, 0, 0.2)",
  codeBackground: "#000000",
}
